import React, { useEffect, useState } from 'react';
import GridInputs from '../../../components/common/inputs/GridInputs';
import { IData } from './helpers/Interface';
import axios from 'axios';
import { SubmitButton } from '../../../components/common/button/CustomButtons';
import useConfirm from '../../../components/common/useConfirm';
import SelectGridMui from '../../../components/common/selectscustom/SelectGridMui';
import { MenuItem } from '@mui/material';

const Create = ({
  id,
  setIsModal,
}: {
  id?: string | null;
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [vendorData, setVendorData] = useState<IData>({
    vender_name: '',
    item_name: '',
    vendor_type: '',
    status: '',
    remarks: '',
  });
  const [isSubmit, setIsSubmit] = useState(false);
  const [DialogSubmit, confirmSubmit] = useConfirm(
    `${id ? 'Update Vendor' : 'Create Vendor'}`,
    `Are you sure you want to ${id ? 'update' : 'save'} this?`
  );
  useEffect(() => {
    if (id) {
      axios
        .get(`/api/vendorRoute/${id}`)
        .then((res) => {
          setVendorData(res.data);
        })
        .catch((err) => console.log(err));
    }
  }, [id]);

  function handleCustomerData(e: React.ChangeEvent<HTMLInputElement>) {
    setVendorData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  const handleSumbit = async () => {
    setIsSubmit(true);
    const ans = await confirmSubmit();
    if (!ans) return;
    if (id) {
      await axios
        .put(`/api/vendorRoute/${id}`, vendorData)
        .then((res) => {
          setIsSubmit(false);
          setIsModal(false);
        })
        .catch((err) => console.log(err));
    } else {
      await axios
        .post('/api/vendorRoute', vendorData)
        .then((res) => {
          setIsSubmit(false);
          setIsModal(false);
        })
        .catch((err) => {
          setIsSubmit(false);
          console.log(err);
        });
    }
  };

  return (
    <>
      <GridInputs
        id={'vender_name'}
        name={'vender_name'}
        html_for={'vender_name'}
        label_name={'Party Name:'}
        input_type={'text'}
        focusType={'onblur'}
        value={vendorData?.vender_name || ''}
        onChange={handleCustomerData}
      />
      <GridInputs
        id={'item_name'}
        name={'item_name'}
        html_for={'item_name'}
        label_name={'Item Name / Code:'}
        input_type={'text'}
        focusType={'onblur'}
        value={vendorData?.item_name || ''}
        onChange={handleCustomerData}
      />
      <SelectGridMui
        name="vendor_type"
        value={vendorData?.vendor_type || ''}
        lable={'Supplier Type'}
        onChange={(e: any) => handleCustomerData(e)}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        <MenuItem value="RAW MATERIAL">RAW MATERIAL</MenuItem>
        <MenuItem value="NOT APPROVED">TOOL MATERIAL</MenuItem>
        <MenuItem value="BOP">BOP </MenuItem>
        <MenuItem value="PLATER"> PLATER</MenuItem>
      </SelectGridMui>
      <SelectGridMui
        name="status"
        value={vendorData?.status || ''}
        lable={'Status'}
        onChange={(e: any) => handleCustomerData(e)}
      >
        <MenuItem value="">
          <em>None</em>
        </MenuItem>
        <MenuItem value="APPROVED">APPROVED</MenuItem>
        <MenuItem value="NOT APPROVED">NOT APPROVED</MenuItem>
      </SelectGridMui>

      <GridInputs
        id={'remarks'}
        name={'remarks'}
        html_for={'remarks'}
        label_name={'Remarks:'}
        input_type={'text'}
        focusType={'onblur'}
        value={vendorData?.remarks || ''}
        onChange={handleCustomerData}
        last_child={2}
      />
      <div
        className="btn_save"
        style={{
          position: 'absolute',
          right: '140px',
          top: '-0.6px',
        }}
      >
        <SubmitButton
          label={`${id ? 'update' : 'submit'}`}
          type="button"
          onClick={handleSumbit}
        />
      </div>
      <DialogSubmit />
    </>
  );
};

export default Create;
